<template>
  <div>
    <div
      v-bind="$attrs"
      id="g_id_onload"
      :data-client_id="client_id"
      :data-context="dataContext"
      :data-ux_mode="dataUxMode"
      data-callback="loginWithGoogle"
      :data-itp_support="itpSupport"
    />
    <div
      v-bind="$attrs"
      class="g_id_signin"
      :data-type="dataType"
      :data-shape="dataShape"
      :data-theme="dataTheme"
      :data-text="dataText"
      :data-size="dataSize"
      :data-logo_alignment="dataLogoAlignment"
      :data-width="dataWidth"
      :data-locale="convertLocale(currentLocale, 'bcp47')"
    />
  </div>
</template>

<script>
export default {
  name: 'AtGoogleLogin',
  /**
   * Props for modifying Google login button styles & attributes
   *
   * @link https://developers.google.com/identity/gsi/web/reference/html-reference
   */
  props: {
    dataContext: {
      type: String,
      default: 'use',
      validator: (val) => {
        return ['signin', 'signup', 'use'].includes(val)
      }
    },
    dataUxMode: {
      type: String,
      default: 'popup',
      validator: (val) => {
        return ['popup', 'redirect'].includes(val)
      }
    },
    itpSupport: {
      type: Boolean,
      default: true
    },
    dataType: {
      type: String,
      default: 'standard',
      validator: (val) => {
        return ['standard', 'icon'].includes(val)
      }
    },
    dataShape: {
      type: String,
      default: 'rectangular',
      validator: (val) => {
        return ['rectangular', 'pill', 'circle', 'square'].includes(val)
      }
    },
    dataTheme: {
      type: String,
      default: 'outline',
      validator: (val) => {
        return ['outline', 'filled_blue', 'filled_black'].includes(val)
      }
    },
    dataText: {
      type: String,
      default: 'continue_with',
      validator: (val) => {
        return ['signin_with', 'signup_with', 'continue_with', 'signin'].includes(val)
      }
    },
    dataSize: {
      type: String,
      default: 'large',
      validator: (val) => {
        return ['large', 'medium', 'small'].includes(val)
      }
    },
    dataLogoAlignment: {
      type: String,
      default: 'center',
      validator: (val) => {
        return ['left', 'center'].includes(val)
      }
    },
    dataWidth: {
      type: [String, Number],
      default: '300'
    }
  },
  data () {
    return {
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID
    }
  },
  created () {
    document.getElementById('google-jssdk')?.remove()
    window.loginWithGoogle = this.loginWithGoogle
  },
  mounted () {
    this.initializeGoogle()
  },
  methods: {
    initializeGoogle () {
      // Insert Google SDK if not found in header
      const id = 'google-jssdk'
      if (!document.getElementById(id)) {
        const fjs = document.getElementsByTagName('script')[0]
        const js = document.createElement('script')
        js.id = id
        js.src = 'https://accounts.google.com/gsi/client'
        fjs.parentNode.insertBefore(js, fjs)
      }
    },
    loginWithGoogle (response) {
      const decodedJwt = this.parseJwt(response.credential)
      const obj = {
        social_media: 'GOOGLE',
        user_id: decodedJwt.sub,
        access_token: response.credential
      }
      this.$emit('login:success', obj)
    },
    parseJwt (token) {
      return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString())
    }
  }
}
</script>
